import React, { Fragment, isValidElement, useEffect } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isFunction } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../../inline-image/inline-image.js';
import { TabStyle } from '../tab-constants.js';
import './internal-tab.css';
const renderIcon = (props) => {
    const { icon } = props;
    if (!icon) {
        return null;
    }
    if (isValidElement(icon)) {
        return icon;
    }
    return React.createElement(InlineImage, { className: "c-internal-tab__icon", src: icon });
};
const renderText = (props) => {
    const { label } = props;
    if (!label) {
        return null;
    }
    return React.createElement("span", { className: "c-internal-tab__text" }, MessageService.translate(label));
};
const renderBadge = (props) => {
    const { badge, count } = props;
    if (!badge && !count) {
        return null;
    }
    return React.createElement("span", { className: "c-internal-tab__badge" }, count || badge);
};
const renderTextOnlyStyle = (props) => {
    return (React.createElement(Fragment, null,
        renderText(props),
        renderBadge(props)));
};
const renderIconOnlyStyle = (props) => {
    return (React.createElement(Fragment, null,
        renderIcon(props),
        renderBadge(props)));
};
const renderTextAndIconInlineStyle = (props) => {
    return (React.createElement(Fragment, null,
        renderIcon(props),
        renderText(props),
        renderBadge(props)));
};
const renderTextAndIconStackedStyle = (props) => {
    return (React.createElement(Fragment, null,
        renderIcon(props),
        React.createElement("div", { className: "c-internal-tab__text-and-badge" },
            renderText(props),
            renderBadge(props))));
};
const ContentRenderers = {
    [TabStyle.ICON_AND_TEXT_INLINE]: renderTextAndIconInlineStyle,
    [TabStyle.ICON_AND_TEXT_STACKED]: renderTextAndIconStackedStyle,
    [TabStyle.ICON_ONLY]: renderIconOnlyStyle,
    [TabStyle.TEXT_ONLY]: renderTextOnlyStyle,
};
function InternalTab(props) {
    const { enabled, isActive, onClick, onContextMenuClick, onDoubleClick, onNavigateTo, style, uppercase, visible, } = props;
    useEffect(() => {
        if (isActive && isFunction(onNavigateTo)) {
            onNavigateTo();
        }
    }, [isActive]);
    if (!visible) {
        return null;
    }
    const className = classNames({
        'c-internal-tab': true,
        'c-internal-tab--uppercase': uppercase,
        'disabled': !enabled,
        'is-active': isActive,
        'text-and-icon-inline': TabStyle.ICON_AND_TEXT_INLINE === style,
        'text-and-icon-stacked': TabStyle.ICON_AND_TEXT_STACKED === style,
    });
    const renderer = ContentRenderers[style];
    const content = isFunction(renderer) ? renderer(props) : null;
    return (React.createElement("div", { className: className, onClick: (event) => onClick(new ClickEvent(event)), onContextMenu: (event) => onContextMenuClick(new ClickEvent(event)), onDoubleClick: (event) => onDoubleClick(new ClickEvent(event)) }, content));
}
export { InternalTab, };
//# sourceMappingURL=internal-tab.js.map